const CHANNEL_QUERY_TERMS = [
  'discord',
  'discprd',
  'slack',
  'whatsapp',
  'telegram',
  'messenger',
  'intercom',
  'zendesk',
  'hubspot',
  'facebook',
];

export const looksLikeChannelQuery = (query: string): boolean => {
  const normalizedQuery = query.trim().toLowerCase();
  return (
    normalizedQuery.length >= 2 &&
    CHANNEL_QUERY_TERMS.some(
      (term) => term.startsWith(normalizedQuery) || normalizedQuery.startsWith(term),
    )
  );
};
